import { Component, OnInit, ViewChild } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/api';
import { Validators, FormControl, FormGroup } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { DynamicDialogRef } from 'primeng/api';
import { DialogService} from 'primeng/api';
import { NewmemberService } from '../../services/newmember.service';
import { OtpComponent } from '../otp/otp.component';

@Component({
  selector: 'app-mobilenumberupdate',
  templateUrl: './mobilenumberupdate.component.html',
  styleUrls: ['./mobilenumberupdate.component.css'],
  providers: [DialogService]
})
export class MobilenumberupdateComponent implements OnInit {

  @ViewChild("otpComp") private otpComp: OtpComponent;

  cardHolders = [];
  populateForm:any = {};
  uploadedFiles:any = {};
  ch:any = {};
  contactForm: FormGroup;
  contactFormValid: boolean = true;
  verified: boolean = false;
  verifiedNo: string;
  otpInfo: any = {};
  pNumber: any;
  addonList: any = [];
  otpFlag:boolean;
  constructor(public config: DynamicDialogConfig, public nms: NewmemberService, public messageService: MessageService, public ref: DynamicDialogRef) { }

  ngOnInit() {
    this.addonList = this.config.data.info;
    this.otpFlag = this.config.data.otpFlag;
    for(let c of this.config.data.info) {

      if(c.cardHolderNbr <= 100) {
        if((c.status == 'A' || c.status == 'ONHOLD') && (c.cardHolderType == 'P' || this.otpFlag)) {
          this.cardHolders.push(c);
        }
      }
      if(c.cardHolderType == 'P' && (c.status == 'A' || c.status == 'QC PENDING' || c.status == 'ONHOLD')) {
        this.pNumber = c.phoneNbr
      }
    }
    this.populateForm = this.config.data.populate;
    this.contactForm = new FormGroup({
      cardHolderNbr: new FormControl('', Validators.compose([
        Validators.required
      ])),
      phoneNbr: new FormControl('', Validators.compose([
        Validators.required
      ])),
      previousPhoneNbr: new FormControl()
    });
  }

  contactInfo() {
    var otpInfo: any = {};
    otpInfo.phoneNbr = this.contactForm.value.phoneNbr;
    otpInfo.maMembershipId = this.nms.mlid;
    otpInfo.category = "PHONE_NUMBER_CHANGE_OTP";
    return otpInfo;
   }

  cardChange(e) {
    for(let c of this.cardHolders) {
      if(c.cardHolderNbr == e.value) {
        this.contactForm.patchValue({'previousPhoneNbr':c.phoneNbr});
      }
    }
  }

  phoneNumberUpdate(){
    
  }

  resetOTP() {
    
    this.verified = false;

    if (this.otpComp)
    this.otpComp.reInt();
  }

  updateOTPstatus(event) {
      this.verified = event;
      this.verifiedNo = this.contactForm.get('phoneNbr').value;
  }
  
  

  isPhoneNumberUnique(phoneNbr, cardholderNbr) {
    if (this.addonList.length > 0) {
      var addOn = this.addonList.filter(proj => proj.phoneNbr === parseInt(phoneNbr));
      if (addOn[0] != null) {
        for (var index = 0; index < addOn.length; index++) {
          if (addOn[index].status != 'L' && addOn[index].status != 'R' && addOn[index].status != 'S') {
            if (addOn[index].cardHolderNbr != cardholderNbr){
              this.messageService.add({ severity: 'error', summary: 'Update phone number', detail: 'Mobile number is already used by another card holder(' + addOn[index].firstName + '), please change the mobile number.' });
              return false;
            } else if (addOn[index].cardHolderNbr == cardholderNbr && addOn[index].phoneNbr == phoneNbr){
              this.messageService.add({ severity: 'error', summary: 'Update phone number', detail: 'Same mobile number cannot be updated.' });
              return false;
            }
          }
        }
      }
    } 
    return true;
  }

  /*
  isPhoneNumberUnique(phoneNbr, cardholderNbr) {
    if (this.addonList.length > 0) {
      var addOn = this.addonList.filter(proj => proj.phoneNbr === parseInt(phoneNbr));
      if (addOn[0] != null) {
        if (addOn[0].cardHolderNbr != cardholderNbr){
          this.messageService.add({ severity: 'error', summary: 'Update phone number', detail: 'Mobile number is already used by another card holder, please change the mobile number.' });
          return false;
        } else {
          this.messageService.add({ severity: 'error', summary: 'Update phone number', detail: 'Same mobile number cannot be updated.' });
          return false;
        }
      }
    } 
    return true;
  }*/

  saveContact() {
    if(this.contactForm.valid) {
      
      for(let c of this.config.data.info) {
        if(c.cardHolderNbr == this.contactForm.get('cardHolderNbr').value) {
          if(c.cardHolderType == 'A') {
            if(this.contactForm.get('phoneNbr').value == this.pNumber) {
              this.messageService.add({ severity: 'error', summary: 'Update phone number', detail: 'Phone number same as primary phone number' });
              return;
            }
          }
        }
      }
      if (!this.isPhoneNumberUnique(this.contactForm.value.phoneNbr, this.contactForm.value.cardHolderNbr)){
        return;
      }
      if(!this.verified){
        this.messageService.add({ severity: 'error', summary: 'Update phone number', detail: 'Mobile number verification not done' });
        return;
      }
      let data:any = {};
      data.phoneNbr = parseInt(this.contactForm.get('phoneNbr').value);
      
      data.cardHolderNbr = parseInt(this.contactForm.get('cardHolderNbr').value);
      this.nms.mobileNumberUpdate(data).subscribe((res: any) => {
        if (res.code == "SUCCESS") {
          this.messageService.add({ severity: 'success', summary: 'Update phone number', detail: 'Updated Successfully.' });
          this.ref.close(true);
        }
      }, err => {
        this.messageService.add({ severity: 'error', summary: 'Update phone number', detail: 'update failed' });
      });
    } else {
      this.messageService.add({ severity: 'error', summary: 'Update phone number', detail: 'Please enter all mandatory fields' });
      this.contactFormValid = false;
    }
  }
}
